var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"calendar-view"},[_c('base-calendar',{attrs:{"calendars":_vm.calendars,"schedules":_vm.scheduleList,"view":"week"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }